import { SubsidiariesActionTypes } from "./actionTypes";

export const SubsidiariesActionCreators = {
    getSubsidiaries: () => ({
        type: SubsidiariesActionTypes.GET_SUBSIDIARIES
    }),
    saveSubsidiary: subsidiary => ({
        type: SubsidiariesActionTypes.SAVE_SUBSIDIARY_LOGO,
        payload: {
            subsidiary
        }
    }),
    startSubsidiaryEditing: () => ({
        type: SubsidiariesActionTypes.EDIT_SUBSIDIARY
    }),
    endSubsidiaryEditing: () => ({
        type: SubsidiariesActionTypes.EDIT_SUBSIDIARY_END
    })
};
